import { create } from "zustand";

interface ToggleState {
  isWidgetOpen: boolean;
  toggle: () => void;
  closeWidget : () => void;
  openWidget : () => void;
}

const useToggleWidget = create<ToggleState>((set) => ({
  isWidgetOpen: false,
  toggle: () => set((state) => ({ isWidgetOpen: !state.isWidgetOpen })),
  closeWidget: () => set({ isWidgetOpen: false }),
  openWidget: () => set({ isWidgetOpen: true }),
}));

export default useToggleWidget;
